"use client";

import { useState } from "react";

import { PAGE_TYPES } from "@/lib/briefing";

type Props = {
  /** Vorschlag für das Haupt-Keyword (stärkstes Keyword der Lücke). */
  keyword: string;
  busy: boolean;
  error: string | null;
  onStart: (request: { keyword: string; pageType: string }) => void;
  onCancel: () => void;
};

const FIELD = "h-11 rounded-md border border-field bg-white px-3 text-sm";

/** Rückfrage vor „Briefing starten“ aus einer Lücke: Haupt-Keyword und Seitentyp. Der Entwurf ist kostenlos. */
export function GapBriefing({ keyword, busy, error, onStart, onCancel }: Props) {
  const [value, setValue] = useState(keyword);
  const [pageType, setPageType] = useState("ratgeber");

  return (
    <div role="group" aria-label="Briefing starten bestätigen" className="flex flex-col gap-3 rounded-lg border border-line bg-white px-5 py-4 text-sm">
      <h2 className="text-base font-semibold">Briefing zu „{keyword}“ starten?</h2>
      <p className="max-w-3xl text-[13px] text-muted">
        Es entsteht ein Briefing-Entwurf mit diesem Haupt-Keyword. Keywords, Prompts, Fan-outs, Quellen und Outline entstehen im Briefing wie gewohnt
        und zeigen ihre Kosten vor dem Start. Der Entwurf selbst kostet nichts.
      </p>
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex flex-col gap-1">
          <label htmlFor="gap-keyword" className="text-[13px] font-medium">
            Haupt-Keyword
          </label>
          <input id="gap-keyword" value={value} onChange={(event) => setValue(event.target.value)} className={`${FIELD} w-80 max-w-full`} />
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="gap-page-type" className="text-[13px] font-medium">
            Seitentyp
          </label>
          <select id="gap-page-type" value={pageType} onChange={(event) => setPageType(event.target.value)} className={FIELD}>
            {PAGE_TYPES.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {error && (
        <p role="alert" className="text-[13px] text-danger">
          {error}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          disabled={busy || value.trim() === ""}
          onClick={() => onStart({ keyword: value.trim(), pageType })}
          className="h-11 rounded-md bg-accent px-3.5 text-sm font-medium text-white disabled:opacity-60"
        >
          {busy ? "Wird angelegt …" : "Briefing anlegen"}
        </button>
        <button type="button" onClick={onCancel} className="h-11 rounded-md border border-field bg-white px-3.5 text-sm">
          Abbrechen
        </button>
      </div>
    </div>
  );
}
